import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import { useEffectOnce } from 'react-use'
import _ from 'lodash'
import { getProgramPhaseListPromise } from 'api/ProgramPhase'
import ProgramPhaseTable from './ProgramPhaseTable'
import ProgramPhaseToolbar from './ProgramPhaseToolbar'

const ProgramPhaseList = props => {
  const ref = useRef()
  const location = useLocation()
  const [programPhases, setProgramPhases] = useState([])
  const [params, setParams] = useState({ page: 1 })
  const pageSize = 10

  useEffectOnce(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    setParams({ page: 1, ...too })
  })

  const handleParamsChange = useCallback(
    (payload, delay = 0) => {
      if (ref.current) clearTimeout(ref.current)

      const foo = Object.fromEntries(new URLSearchParams(location.search))
      const too = _.pickBy({ ...foo, page: 1, ...payload }, _.identity)
      setParams(too)

      ref.current = setTimeout(
        () => props.history.push(`?${new URLSearchParams(too)}`),
        delay
      )
    },
    [location.search, props.history]
  )

  function handlePageChange(event, page) {
    handleParamsChange({ page: page + 1 })
  }

  useEffect(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())
    getProgramPhaseListPromise({ ...too, size: pageSize }).then(resp =>
      setProgramPhases(resp)
    )
  }, [location.search])

  const handleSearchChange = useCallback(
    value => {
      handleParamsChange({ programName: value, page: 1 }, 500)
    },
    [handleParamsChange]
  )

  return (
    <div className={'root'}>
      <ProgramPhaseToolbar
        params={params}
        handleSearchChange={handleSearchChange}
        history={props.history}
      />
      <div className={'content'}>
        <ProgramPhaseTable
          data={programPhases}
          page={params.page}
          onPageChange={handlePageChange}
          pageSize={pageSize}
          {...props}
        />
      </div>
    </div>
  )
}

export default ProgramPhaseList
